export default __webpack_public_path__ + "assets/26adf1a8b0d886d0baaff9dcc4ba3155.svg";